import React from 'react';
import { Author } from '../../components/Author';
import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';
import { ImageProps } from '../../components/Image/types';

export interface AuthorProps extends DefaultBsComponent {
  authorImage?: ImageProps;
  authorName: string;
  authorPosition?: string;
  locale?: 'fr' | 'en' | 'es';
  updateTime?: Date;
  readingTime?: number; // seconds
}

export const AuthorCard = ({
  authorImage,
  authorName,
  authorPosition,
  locale,
  updateTime,
  readingTime,
  className,
  ...props
}: AuthorProps) => {
  return (
    <Author {...props} className={classNames('AuthorCard', className)}>
      {authorImage && <Author.Image {...authorImage} />}
      <Author.Infos>
        <div className="flex flex-row">
          <Author.Name className="text-neutral-301">{authorName}</Author.Name>
          {
            <Author.Position
              className="text-neutral-301"
              disableMobile={true}
            >{`, ${authorPosition}`}</Author.Position>
          }
        </div>
        <div className="flex flex-row gap-3 flex-wrap">
          {updateTime && <Author.Date date={updateTime} locale={locale} />}
          {!!readingTime && (
            <Author.ReadingTime timeSecond={readingTime} locale={locale} />
          )}
        </div>
      </Author.Infos>
    </Author>
  );
};
